import { Tabs } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import PageLayout from '../../components/page-layout/page-layout'
import { dynamicRoutes } from '../../constants/routes'
import useRouteTab from '../../hooks/use-route-tab'
import PrintHistoryTable from './components/print-history-table/print-history-table'

const tabs = ['flexo', 'digital'] as const

const tabsItems = [
    {
        label: 'Флексо печать',
        key: 'flexo',
        children: <PrintHistoryTable tab='flexo' />,
    },
    {
        label: 'Цифровая печать',
        key: 'digital',
        children: <PrintHistoryTable tab='digital' />,
    },
]

const TabsStyled = styled(Tabs)`
    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
    }
`

const PrintHistoryPage: FC = () => {
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'flexo',
        getRoute: dynamicRoutes.printHistoryTab,
    })

    return (
        <PageLayout title={'История печати'}>
            <TabsStyled
                activeKey={activeKey}
                onChange={onTabChange}
                destroyInactiveTabPane
                type={'card'}
                size={'large'}
                items={tabsItems}
                style={{ flex: '1 1' }}
            />
        </PageLayout>
    )
}

export default PrintHistoryPage
